module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%- helpers.renderSection('filter'); %>\n<%\nif(model.nrOfVisibleElements > 0){\n%><div class=\"summary\"><%= model.nrOfVisibleElements %> / <%= model.nrOfElements %></div><%\n}\n%>\n<ol>\n<%\nif(model.nrOfVisibleElements <= 0){\nif((model.resourceFilters || {}).search || utils.collectionSize((model.resourceFilters || {}).listOfCategoryDataIDs) > 0){\n%><li class=\"active empty\">keine Suchergebnisse gefunden...</li><%\n} else {\n%><li class=\"active empty\">Bitte bestimmen Sie mindestens einen Suchparameter<img src=\"/images/logo_bzfgl.jpg\" title=\"Bundeszentrum für gesellschaftliches Lernen\" alt=\"Bundeszentrum für gesellschaftliches Lernen\"></li><%\n}\n}\nvar l, literature, literatureAttributes, attachments, a, attachment, url, additionalClasses;\nfor(l in resourceData.data || []){\nliterature = resourceData.data[l] || {};\nliteratureAttributes = literature.attributes || {};\nliteratureID = literatureAttributes[literature.primaryKey || 0] || 0;\nattachments = literatureAttributes.attachments || [];\nif(literatureAttributes.inactiveAttachments === true){\nattachments = [];\n}\nadditionalClasses = [];\n// if(!literatureAttributes.active) {\n// \tadditionalClasses.push('deactivated');\n// }\nif(model.visibleLiteratureIDs[literatureID]) {\nadditionalClasses.push('active');\n} else {\nadditionalClasses.push('inactive');\n}\n%>\n<li class=\"<%- additionalClasses.join(' ') %>\">\n<div class=\"top\">\n<div class=\"controls\">\n<div class=\"icon edit showOnLoggedIn\" data-id=\"<%- literatureID %>\"><i class=\"fi fi-edit\"></i></div>\n<div class=\"icon showOnLoggedOut\"><i class=\"fi fi-book\"></i></div>\n<div class=\"icon delete showOnLoggedIn\" data-id=\"<%- literatureID %>\"><i class=\"fi fi-trash\"></i></div>\n</div>\n<div class=\"title\">\n<%= literatureAttributes.title %>\n</div>\n<div class=\"files\">\n<ul>\n<%\nfor(a in attachments){\nattachment = attachments[a] || {};\nif(attachment.url){\n%>\n<li>\n<a href=\"<%= attachment.url %>\" target=\"_blank\" title=\"<%= attachment.name %>\">\n<i class=\"<%= utils.media.file.getSymbolClass(attachment.extension) %>\"></i>\n</a>\n</li>\n<%\n}\n}\n%>\n</ul>\n</div>\n</div>\n<div class=\"bottom\">\n<div class=\"footer\">\n<%\nvar footerTitle = literatureAttributes.footerTitle || literatureAttributes.footerLink || '';\nvar footerLink = literatureAttributes.footerLink || '';\nif(footerLink){\n%><a href=\"<%= footerLink %>\" target=\"_blank\" title=\"<%= footerTitle %>\"><%= footerTitle %></a><%\n} else if(footerTitle) {\n%><%= footerTitle %><%\n}\n%>\n</div>\n</div>\n</li>\n<%\n}\n%>\n</ol>\n</div>"
  , __filename = "components/templates/controller/list.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 3
    ; 
if(model.nrOfVisibleElements > 0){

    ; __line = 5
    ; __append("<div class=\"summary\">")
    ; __append(escapeFn( model.nrOfVisibleElements ))
    ; __append(" / ")
    ; __append(escapeFn( model.nrOfElements ))
    ; __append("</div>")
    ; 
}

    ; __line = 7
    ; __append("\n<ol>\n")
    ; __line = 9
    ; 
if(model.nrOfVisibleElements <= 0){
if((model.resourceFilters || {}).search || utils.collectionSize((model.resourceFilters || {}).listOfCategoryDataIDs) > 0){

    ; __line = 12
    ; __append("<li class=\"active empty\">keine Suchergebnisse gefunden...</li>")
    ; 
} else {

    ; __line = 14
    ; __append("<li class=\"active empty\">Bitte bestimmen Sie mindestens einen Suchparameter<img src=\"/images/logo_bzfgl.jpg\" title=\"Bundeszentrum für gesellschaftliches Lernen\" alt=\"Bundeszentrum für gesellschaftliches Lernen\"></li>")
    ; 
}
}
var l, literature, literatureAttributes, attachments, a, attachment, url, additionalClasses;
for(l in resourceData.data || []){
literature = resourceData.data[l] || {};
literatureAttributes = literature.attributes || {};
literatureID = literatureAttributes[literature.primaryKey || 0] || 0;
attachments = literatureAttributes.attachments || [];
if(literatureAttributes.inactiveAttachments === true){
attachments = [];
}
additionalClasses = [];
// if(!literatureAttributes.active) {
// 	additionalClasses.push('deactivated');
// }
if(model.visibleLiteratureIDs[literatureID]) {
additionalClasses.push('active');
} else {
additionalClasses.push('inactive');
}

    ; __line = 35
    ; __append("\n<li class=\"")
    ; __line = 36
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<div class=\"top\">\n<div class=\"controls\">\n<div class=\"icon edit showOnLoggedIn\" data-id=\"")
    ; __line = 39
    ; __append( literatureID )
    ; __append("\"><i class=\"fi fi-edit\"></i></div>\n<div class=\"icon showOnLoggedOut\"><i class=\"fi fi-book\"></i></div>\n<div class=\"icon delete showOnLoggedIn\" data-id=\"")
    ; __line = 41
    ; __append( literatureID )
    ; __append("\"><i class=\"fi fi-trash\"></i></div>\n</div>\n<div class=\"title\">\n")
    ; __line = 44
    ; __append(escapeFn( literatureAttributes.title ))
    ; __append("\n</div>\n<div class=\"files\">\n<ul>\n")
    ; __line = 48
    ; 
for(a in attachments){
attachment = attachments[a] || {};
if(attachment.url){

    ; __line = 52
    ; __append("\n<li>\n<a href=\"")
    ; __line = 54
    ; __append(escapeFn( attachment.url ))
    ; __append("\" target=\"_blank\" title=\"")
    ; __append(escapeFn( attachment.name ))
    ; __append("\">\n<i class=\"")
    ; __line = 55
    ; __append(escapeFn( utils.media.file.getSymbolClass(attachment.extension) ))
    ; __append("\"></i>\n</a>\n</li>\n")
    ; __line = 58
    ; 
}
}

    ; __line = 61
    ; __append("\n</ul>\n</div>\n</div>\n<div class=\"bottom\">\n<div class=\"footer\">\n")
    ; __line = 67
    ; 
var footerTitle = literatureAttributes.footerTitle || literatureAttributes.footerLink || '';
var footerLink = literatureAttributes.footerLink || '';
if(footerLink){

    ; __line = 71
    ; __append("<a href=\"")
    ; __append(escapeFn( footerLink ))
    ; __append("\" target=\"_blank\" title=\"")
    ; __append(escapeFn( footerTitle ))
    ; __append("\">")
    ; __append(escapeFn( footerTitle ))
    ; __append("</a>")
    ; 
} else if(footerTitle) {

    ; __line = 73
    ; __append(escapeFn( footerTitle ))
    ; 
}

    ; __line = 75
    ; __append("\n</div>\n</div>\n</li>\n")
    ; __line = 79
    ; 
}

    ; __line = 81
    ; __append("\n</ol>\n</div>")
    ; __line = 83
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/controller/list.ejs

}